import React from "react";
import BrilloLogo from "@/components/BrilloLogo";
import { WHATSAPP_LINK, WHATSAPP_NUMBER } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-[#e5e7eb] bg-[#f8f9fa]">
      <div className="bf-container py-10 grid gap-8 md:grid-cols-3">
        <div>
          <BrilloLogo className="h-10 w-auto" />
          <p className="mt-3 text-sm text-[#666666] leading-relaxed max-w-xs">
            Soluciones hipotecarias claras y rápidas. Precalificación en 3 minutos.
          </p>
        </div>
        <div className="text-sm">
          <p className="bf-eyebrow mb-2">Contacto</p>
          <p className="text-[#333333]">
            <a href="mailto:mario@brillofinance.com" className="bf-link" data-testid="footer-email">
              mario@brillofinance.com
            </a>
          </p>
          <p className="text-[#333333] mt-1">
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="bf-link" data-testid="footer-whatsapp">
              WhatsApp: +52 33 4406 5965
            </a>
          </p>
          <p className="text-[#666666] mt-1">
            <a href="https://brillofinance.com" target="_blank" rel="noopener noreferrer" className="bf-link">
              brillofinance.com
            </a>
          </p>
        </div>
        <div className="text-sm">
          <p className="bf-eyebrow mb-2">Legal</p>
          <p className="text-[#666666] leading-relaxed">
            © {new Date().getFullYear()} Brillo Finance. Todos los derechos reservados.
          </p>
          <p className="text-[#666666] mt-1 text-xs">
            Los productos crediticios están sujetos a aprobación. La precalificación no constituye una oferta vinculante.
          </p>
        </div>
      </div>
      <div className="border-t border-[#e5e7eb] py-3 text-center text-xs text-[#666666]">
        RÁPIDO. CLARO. CONTIGO.
      </div>
    </footer>
  );
}
